import classNames from 'classnames';
import React from 'react';

import style from './LabelInput.module.scss';
import { DoneIcon } from './Icon';

interface LabelInputProps {
  type: string;
  label: string;
  value?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  done?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLDataElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  children?: React.ReactNode;
  dataId?: string;
}

interface LabelInputState {
  isFocus: boolean;
}

export class LabelInput extends React.PureComponent<LabelInputProps, LabelInputState> {
  state: LabelInputState = {
    isFocus: false,
  };

  onFocus = () => {
    this.setState({ isFocus: true });
    this.props.onFocus && this.props.onFocus();
  };

  onBlur = () => {
    this.setState({ isFocus: false });
    this.props.onBlur && this.props.onBlur();
  };

  render() {
    const { children, className, disabled, error, label, onChange, placeholder, type, value, done, dataId } =
      this.props;
    const { isFocus } = this.state;

    return (
      <>
        <div className={classNames(style.inputGroup, isFocus && style.focus, error && style.invalid)}>
          <label className={style.labelControl}>{label}</label>
          <input
            data-id={dataId}
            type={type}
            placeholder={placeholder}
            value={value || ''}
            className={className}
            disabled={disabled}
            onChange={onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
          {done && (
            <div className={style.done}>
              <DoneIcon />
            </div>
          )}
          {children}
        </div>
      </>
    );
  }
}

export interface SelectOption {
  id: number;
  name: string;
  value: string;
}

interface LabelSelectProps {
  label: string;
  options: SelectOption[];
  value?: string;
  placeholder?: string;
  className?: string;
  isInvalid?: boolean;
  done?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLDataElement>) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  dataId?: string;
}

interface LabelSelectState {
  isFocus: boolean;
}

export class LabelSelect extends React.PureComponent<LabelSelectProps, LabelSelectState> {
  state: LabelSelectState = {
    isFocus: false,
  };

  onFocus = () => {
    this.setState({ isFocus: true });
    this.props.onFocus && this.props.onFocus();
  };

  onBlur = () => {
    this.setState({ isFocus: false });
    this.props.onBlur && this.props.onBlur();
  };

  render() {
    const { className, isInvalid, label, options, placeholder, value, onChange, done, dataId } = this.props;
    const { isFocus } = this.state;

    return (
      <div className={classNames(style.inputGroup, isFocus && style.focus, isInvalid && style.invalid)}>
        <label className={style.labelControl}>{label}</label>
        <select
          data-id={dataId}
          value={value || placeholder}
          onChange={onChange}
          className={classNames(className, value || style.placeholder)}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        >
          <option disabled={true}>{placeholder}</option>
          {options.map((option) => {
            return (
              <option key={option.id} value={option.value}>
                {option.name}
              </option>
            );
          })}
        </select>
        {done && (
          <div className={style.done}>
            <DoneIcon />
          </div>
        )}
      </div>
    );
  }
}
